/**
 * Anbefalede baggrunds-intervaller (B2B polling review).
 * Tune kun her — komponenter importerer disse værdier.
 */

/** Users/Session — auth keepalive (JWT/cookie, ingen DB). Plan: 60–120 s. */
export const AUTH_SESSION_PROBE_MS = 120000;

/**
 * Users/Me — profil + ShowUsSizes (DB). Kun nødvendig ved login/F5 og sjælden sync;
 * ShowUsSizes opdateres lokalt via UpdateSizeDisplay. Session dækker auth imellem.
 */
export const USER_PROFILE_REFRESH_MS = 300000;

/** build.json — deploy-version → reload ved ændring. */
export const BUILD_VERSION_CHECK_MS = 200000;

/** Wishlist/GetWishListSummary — fingerprint (Plan O1: 30–60 s, ikke 15 s). */
export const WISHLIST_POLL_INTERVAL_MS = 60000;

export const WISHLIST_VISIBILITY_DEBOUNCE_MS = 60000;

export const WISHLIST_INITIAL_DELAY_MS = 3000;

/** Routes med wishlist i header — poll springes over på login m.m. */
export const WISHLIST_POLL_ROUTE_PREFIXES = [
    '/shop',
    '/search',
    '/wishlist',
    '/dashboard',
    '/checkout',
    '/previeworder',
    '/my-molo',
    '/my-orders',
    '/order-history',
];

/** Order/GetMyOpenOrders — kurv/dropup (Plan: ~30 s). */
export const OPEN_ORDERS_POLL_INTERVAL_MS = 30000;

/** Langsommere liste-poll mens GetOrderRevision kører (Plan O3). */
export const OPEN_ORDERS_POLL_INTERVAL_MS_WHILE_REVISION_ACTIVE = 60000;

export const OPEN_ORDERS_VISIBILITY_DEBOUNCE_MS = 30000;

/** Order/GetOrderRevision — collab / remote change (Plan: 10 s når ordre overvåges). */
export const ORDER_REVISION_POLL_INTERVAL_MS = 10000;

export const ORDER_REVISION_POLL_INTERVAL_SECONDS =
    ORDER_REVISION_POLL_INTERVAL_MS / 1000;

/** Order/GetOrderRevisionLog — dashboard activity feed (Plan: 10 s, pause når fane skjult). */
export const ORDER_ACTIVITY_LOG_POLL_INTERVAL_MS = 10000;
